import { themedStyled } from 'common/styles/styletron.theme';

const styles = {
  common: { display: 'flex', marginTop: '8px', marginBottom: '8px' },
};

export const SummaryLeftContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'center',
});

export const SummaryRightContainer = themedStyled(
  SummaryLeftContainer,
  ({ $theme }) => ({
    marginTop: '16px',
    justifyContent: 'space-between',
    flex: 1,
    [$theme.mediaQuery.md]: {
      flex: 0,
      marginTop: 0,
    },
  }),
);

export const ScheduleCardHeaderRight = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
}));

export const ScheduleCardHeader = themedStyled('div', {
  display: 'flex',
  width: '100%',
});

export const ScheduleCardHeaderLeft = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  [$theme.mediaQuery.md]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
}));

export const OtherContainer = themedStyled('div', {
  display: 'flex',
  justifyContent: 'space-between',
});

export const TotalContent = themedStyled('div', {
  display: 'flex',
  justifyContent: 'end',
});

export const TotalItemContent = themedStyled('div', ({ $theme }) => ({
  ...styles.common,
  justifyContent: 'space-between',
  alignItems: 'center',
  minWidth: '100%',
  [$theme.mediaQuery.md]: {
    minWidth: '50%',
    maxWidth: '500px',
  },
}));
